import * as R from "remeda";
import { useState } from "react";

import { MissionEventRecord, MissionRecord } from "../types";
import { topologicalSort } from "./ordering";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LinearProgress from "@mui/material/LinearProgress";

import Chip from "@mui/material/Chip";
import Grow from "@mui/material/Grow";
import Stack from "@mui/material/Stack";

import Button from "@mui/material/Button";

import {
	CreateBase,
	Identifier,
	RecordContextProvider,
	useListContext,
	useRecordContext,
} from "react-admin";
import { CustomEventDialog } from "./CustomEventDialog";
import { UpdateEventDialog } from "./UpdateEventDialog";
import { eventMarked } from "./functions";

export const Events = () => {
	const { data: missionEvents = [], isLoading } =
		useListContext<MissionEventRecord>();
	const [showAllEvents, setShowAllEvents] = useState<boolean>(false);
	const [openDialogEventId, setOpenDialogEventId] = useState<Identifier | null>(
		null
	);

	const mission = useRecordContext<MissionRecord>();
	const [openDialogCustomEvent, setOpenDialogCustomEvent] =
		useState<boolean>(false);

	const futureEvents = R.reject(missionEvents, eventMarked);
	const { immediate, remaining } = topologicalSort(futureEvents);

	const displayedEvents = showAllEvents
		? [...immediate, ...remaining]
		: immediate;

	const closeEventDialog = () => {
		setOpenDialogEventId(null);
	};
	const closeCustomEventDialog = () => {
		setOpenDialogCustomEvent(false);
	};

	return (
		<>
			<Typography variant="h2" gutterBottom>
				Mission events
			</Typography>
			<Box padding={2} sx={{ border: 1, borderColor: "divider" }}>
				{isLoading ? (
					<Box padding={2}>
						<LinearProgress />
					</Box>
				) : (
					<>
						<Stack direction="row" marginBottom={1} flexWrap="wrap">
							{displayedEvents.map((missionEvent) => (
								<RecordContextProvider
									key={missionEvent.id}
									value={missionEvent}
								>
									{openDialogEventId === missionEvent.id && (
										<UpdateEventDialog closeDialog={closeEventDialog} />
									)}
									<Grow in>
										<Chip
											color="primary"
											label={missionEvent.name}
											onClick={() => setOpenDialogEventId(missionEvent.id)}
											sx={{
												margin: 1,
												boxShadow: 1,
											}}
										/>
									</Grow>
								</RecordContextProvider>
							))}
							{openDialogCustomEvent && (
								<CreateBase record={{ mission_id: mission.id }}>
									<CustomEventDialog closeDialog={closeCustomEventDialog} />
								</CreateBase>
							)}
							<Grow in>
								<Chip
									label="Custom event"
									onClick={() => setOpenDialogCustomEvent(true)}
									sx={{ margin: 1, boxShadow: 1 }}
								/>
							</Grow>
						</Stack>
						{!R.isEmpty(remaining) && (
							<>
								{showAllEvents ? (
									<Button
										size="small"
										endIcon={<ExpandLessIcon />}
										onClick={() => setShowAllEvents(false)}
									>
										Hide future events
									</Button>
								) : (
									<Button
										size="small"
										endIcon={<ExpandMoreIcon />}
										onClick={() => setShowAllEvents(true)}
									>
										Show all
									</Button>
								)}
							</>
						)}
					</>
				)}
			</Box>
		</>
	);
};
